import React from 'react'
import PropTypes from 'prop-types'
import { StyledButton as Button } from '../../common/Button'
import { StyledDetailsBox as DetailsBox } from '../../common/DetailsBox'
import { StyledFormElement as FormElement } from '../../common/FormElement'
import Text from 'common/components/Text'
import MultiUseLinkContainer from './MultiUseLinkContainer'
import { Icon } from 'common/components/Icon'

export const MultiUseLink = ({
  toggleShare,
  copyLink,
  share,
  item, // item exists but may not be reliable and may be phased out
  link,
  editable,
  t
}) => {
  const Component = editable ? Button : FormElement
  return (
    <DetailsBox outline={!share.disabled}>
      <Component large onClick={toggleShare}>
        <Text normal truncate>
          <Text bold>{t(`share.accessLevel.${share.accessLevel}`)}: </Text>
          {share.disabled
            ? t(`share.multiUseDisabled`)
            : t(`share.multiUse.${item.type}.${share.accessLevel}`)}
        </Text>

        <FormElement.Spacer />

        {editable && (
          <>
            <Text>{t(share.disabled ? 'share.enable' : 'share.disable')}</Text>
            <Icon icon={share.disabled ? 'circle' : 'circle-filled'} />
          </>
        )}
      </Component>
      {!share.disabled && (
        <Button large onClick={copyLink}>
          <Text normal truncate>{link}</Text>
          <FormElement.Spacer />
          <Text>{t('share.copyLink')}</Text>
        </Button>
      )}
    </DetailsBox>
  )
}

MultiUseLink.propTypes = {
  toggleShare: PropTypes.func.isRequired,
  share: PropTypes.object.isRequired
}

export default MultiUseLinkContainer(MultiUseLink)
